import React from 'react';
import { Box, Switch, Tooltip, Typography } from '@mui/material';

const ModelTeamSwitch = ({ checked, onChange }: { checked: boolean, onChange: (event: React.ChangeEvent<HTMLInputElement>) => void }) => (
  <Tooltip title="Toggle between ARG and SLC model teams">
    <Box display="flex" alignItems="center" sx={{ ml: 1 }}>
      <Typography
        variant="body2"
        fontWeight={checked ? 400 : 600}
        color={checked ? 'text.secondary' : 'primary.main'}
        sx={{ minWidth: 28, textAlign: 'right' }}
      >
        ARG
      </Typography>
      <Switch
        checked={checked}
        onChange={onChange}
        size="small"
        sx={{ mx: 0.5 }}
      />
      <Typography
        variant="body2"
        fontWeight={checked ? 600 : 400}
        color={checked ? 'primary.main' : 'text.secondary'}
        sx={{ minWidth: 28 }}
      >
        SLC
      </Typography>
    </Box>
  </Tooltip>
);

export default ModelTeamSwitch;